<div class="skeleton-container">
  @for (s of skeletonItems; track $index) {
    <div class="skeleton-card">
      <div class="card-header">
        <skeleton-body-text class="skeleton-tag"></skeleton-body-text>
        <skeleton-display-text size="large" class="skeleton-title"></skeleton-display-text>
      </div>

      <div class="card-content">
        <skeleton-paragraph [numOfLines]="2" lineHeight="medium"></skeleton-paragraph>
      </div>

      <div class="kpi">
        <skeleton-body-text class="skeleton-kpi-label"></skeleton-body-text>
        <skeleton-body-text class="skeleton-kpi-value"></skeleton-body-text>
      </div>

      <div class="complexity-win">
        <div class="complexity">
          <skeleton-body-text class="skeleton-label"></skeleton-body-text>
          <skeleton-body-text class="skeleton-value"></skeleton-body-text>
        </div>
        <div class="complexity win-rate">
          <skeleton-body-text class="skeleton-label"></skeleton-body-text>
          <skeleton-body-text class="skeleton-value"></skeleton-body-text>
        </div>
      </div>
    </div>
  }
</div>
